module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 1-6da65772eb3e07dbf97d3fc445832db6.jpg";